/**
 * Marking Event Mapper
 * Maps transport layer DTOs to domain models
 */

import type { LC_GetMarkingEventsOut, MarkingEvent } from './eventType.types';

/**
 * Maps marking events response from backend to UI domain model
 */
export const mapMarkingEvents = (
  out: LC_GetMarkingEventsOut,
): MarkingEvent[] => {
  if (!out) return [];
  return out.map((event) => ({ 
    id: event.eventId, 
    description: event.name || '', 
  }));
};
